import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react components for routing our app without refresh
// import { Link } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// import Button from "components/CustomButtons/Button.js";
import Parallax from "components/Parallax/Parallax.js";
// sections for this page
import HeaderLinks from "components/Header/HeaderLinks.js";
import SinglePagePDFViewer from "components/Pdf/SimplePage.js";
import bicentenario from "assets/content/SeparataBicentenario.pdf"
import SectionCarousel from "./Sections/SectionCarousel.js";
import SectionVideo from "./Sections/SectionVideo.js";
import styles from "assets/jss/views/components.js";
import imagebig from "assets/img/bg4.jpg";
import Vidalin from "assets/img/Vidalin.jpg";
import Tierno from "assets/img/Tierno.jpg";

const useStyles = makeStyles(styles);

export default function Components(props) {
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        brand="Bicentenario de Durazno"
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 400,
          color: "primary"
        }}
        {...rest}
      />
      <Parallax image={imagebig}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} md={8}>
              <div className={classes.brand}>
                <h1 className={classes.title}>
                  El Durazno de siempre
                </h1>
                <h3 className={classes.subtitle}>
                Un recorrido por estos últimos doscientos años 
                desde la fundación de Durazno, una rica historia contada por protagonistas.
                </h3>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
      <GridContainer>
      <GridItem xs={12} md={7}>
        <SinglePagePDFViewer pdf={bicentenario} />
      </GridItem>
      <GridContainer
        direction="column"
        justifyContent="center"
        alignItems="center" 
        xs={12} md={5}>
      <GridItem>
        <SectionVideo
        poster={Vidalin}
        title="Video: Intendente Carmelo Vidalín"
        subtitle='Esperanzado en un próspero comienzo de siglo,“Durazno es una ciudad con más futuro que pasado"'
        url="https://bicentenario1.s3.us-east-2.amazonaws.com/ELACONTECER-Vidalin_Bicentenario_2021.mp4"/>
        </GridItem>
        <GridItem>
        <SectionVideo
        poster={Tierno}
        title="Video: Diputado Martín Tierno"
        subtitle="De los recuerdos de las viejas canchas de tenis a un ansiado tercer siglo con gobierno frenteamplista"
        url="https://bicentenario.s3.sa-east-1.amazonaws.com/ELACONTECER-Tierno-Bicentenario_2021.mp4"/>
        </GridItem>
        </GridContainer>
        <GridItem xs={12} md={6}>
        <SectionCarousel/>
        </GridItem>
        </GridContainer>
      </div>
      <Footer />
    </div>
  );
}
